/**
 *
 * @param n: number
 * @returns {number[0,1,...,n-1]}
 */
export function range(n) {
  return [...Array(n).keys()];
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */

export function shuffle(array) {
  let newArray = [...array];
  for (let i = newArray.length - 1; i > 0; i--) {
    const r = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[r]] = [newArray[r], newArray[i]];
  }
  return newArray;
}
